module.exports = __webpack_public_path__ + "img/dynamic-29.a1f83d9c.png";